/** Products currently in development at Victrie, with completion progress. */
export const solutions = [
  { name: "Piua-AI", progress: 90, tagline: "AI-powered platform. Full details coming soon." },
  { name: "YaWote", progress: 95, tagline: "A product for everyone. Full details coming soon." },
  { name: "Riveu", progress: 70, tagline: "Next-generation digital experience. Full details coming soon." },
  { name: "Ailo", progress: 60, tagline: "Intelligent assistant technology. Full details coming soon." },
  { name: "Probtic", progress: 20, tagline: "Early-stage innovation. Full details coming soon." },
];

export function solutionStatus(progress) {
  if (progress >= 90) return { label: "Launching soon", color: "var(--lime)" };
  if (progress >= 50) return { label: "In development", color: "var(--accent-2)" };
  return { label: "Early build", color: "var(--accent)" };
}
